module.exports = __webpack_public_path__ + "img/home3.a809ccf3.jpg";